/**
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.DiscountData} discountData
 */
RoadgamesEvent.Base.get = function(event, discountData) {
	let className = RoadgamesEvent.Any;
	return new className(event, discountData);
};